import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ConditionalNumberTooltip, LoaderComponents, Numeric } from 'components';

interface Props {
  isLoading: boolean;
  value: number;
}

const useStyles = makeStyles({
  root: {
    height: 40,
  },
});

const Value: FC<Props> = ({ isLoading, value }) => {
  const classes = useStyles();

  return (
    <ConditionalNumberTooltip value={value}>
      <Typography variant="h2" className={classes.root}>
        {isLoading ? <LoaderComponents.Block width={30} height={30} /> : <Numeric value={value} />}
      </Typography>
    </ConditionalNumberTooltip>
  );
};

export default Value;
